const config = {
  API_BASE:
    process.env.REACT_APP_API_BASE ||
    (typeof window !== 'undefined' &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
      ? 'https://plaid-financial-system-api.onrender.com'
      : 'http://localhost:3001'),
  /** Google Apps Script Web App URL for discovery / withholding estimator leads */
  DISCOVERY_SHEETS_WEBAPP_URL: (process.env.REACT_APP_DISCOVERY_SHEETS_WEBAPP_URL || '').trim(),
};

// Export default config
export default config;

// Also export API_BASE as named export for backward compatibility
export const { API_BASE } = config;
